export default __webpack_public_path__ + "static/media/logo.a62cf917.png";